import { Button, Dialog, DialogActions, DialogContent, Grid, TextField, AppBar, Toolbar, Typography, debounce } from "@mui/material"
import { useAppSelector } from "../../../../../hooks/store-hooks"
import CloseIcon from '@mui/icons-material/Close';
import { useProjetosService } from "../../../../../../use-cases/geo-veles"
import { useUIService } from "../../../../../../use-cases/ui";
import { useEffect } from "react";

export const FormCreateProjeto = () => {
    // State
    const { createProjetoForm } = useAppSelector((state) => state.projetos)
    // Service
    const {
        setOpenCreateProjetoForm,
        setCreateProjetoFormNome,
        createProjeto
    } = useProjetosService()
    const { changeTitleAndMetaDesc } = useUIService()
    // Functions
    const handleClose = () => {
        setOpenCreateProjetoForm(false)
    }
    // useEffect
    useEffect(() => {
        changeTitleAndMetaDesc({
            metaDesc: 'Criação de projeto',
            title: 'Veles_Geo - Novo projeto'
        })
    }, [changeTitleAndMetaDesc])

    return (
        <>
            <Dialog
                open={true}
                fullScreen
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        createProjeto();
                    },
                }}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                            Criar Projeto
                        </Typography>
                        <Button
                            color="inherit"
                            startIcon={<CloseIcon />}
                            onClick={handleClose}
                            aria-label="close"
                        >
                            Fechar
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers={true}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                defaultValue={createProjetoForm.fields.nome}
                                onChange={debounce((e) => {
                                    setCreateProjetoFormNome(e.target.value)
                                }, 500)}
                                error={Boolean(createProjetoForm.touched && createProjetoForm.errors.find(item => item.key === 'nome'))}
                                helperText={
                                    createProjetoForm.errors.find(item => item.key === 'nome')?.message
                                }
                                InputLabelProps={{
                                    shrink: true
                                }}
                                name="nome"
                                fullWidth
                                id="nome"
                                label="Nome do Projeto"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                    >
                        Criar Projeto
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}